import { render, staticRenderFns } from "./view-incident-page.vue?vue&type=template&id=b6c5e984&"
import script from "./view-incident-page.vue?vue&type=script&lang=js&"
export * from "./view-incident-page.vue?vue&type=script&lang=js&"
import style0 from "./view-incident-page.vue?vue&type=style&index=0&id=b6c5e984&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports